import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { GetQuoteApiParameter } from "@MasterBluePrint/Services/CustomQuoteService";
import loadQuote from "@MasterBluePrint/Store/Data/Quotes/Handlers/LoadQuote";
import { QuoteModel } from "@insite/client-framework/Types/ApiModels";
import { getQuoteState } from "@MasterBluePrint/Store/Data/Quotes/QuotesSelector";

type HandlerType = ApiHandler<GetQuoteApiParameter, QuoteModel>;

export const DispatchSetQuoteId: HandlerType = props => {
    props.dispatch({
        type: "Pages/RfqQuoteDetails/SetQuoteId",
        quoteId: props.parameter.quoteId,
    });
};

export const DispatchLoadQuoteIfNeeded: HandlerType = props => {
    const quoteState = getQuoteState(props.getState(), props.parameter.quoteId);
    if (!quoteState.value || !quoteState.value.quoteLineCollection) {
        props.dispatch(loadQuote({ quoteId: props.parameter.quoteId }));
    }
};

export const chain = [DispatchSetQuoteId, DispatchLoadQuoteIfNeeded];

const loadQuoteIfNeeded = createHandlerChainRunner(chain, "LoadQuoteIfNeeded");
export default loadQuoteIfNeeded;
